import React, { useState, useRef, useEffect } from 'react';
import '../App.css';
import '../AppRespopnsive.css';
import '../componentes/builderForm/styles.css';
import {
  FaArrowDown,
  FaSignInAlt,
  FaSignOutAlt,
} from 'react-icons/fa';
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery, useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import Terminos from './terminosDeUso';
import Suscripciones from './suscripciones';
import './Modal.css';
import FilteredPosts from './historialRecto';
import useScrollToBottom from './modulos-propios/useScrolledToBottom';
import useClickOutside from './modulos-propios/useClickOutside';
import ButtonGroup from './icons/buttonGroup_sinDash';
import ToolTipBarra from './icons/TooltipBarra';
import client from '../apolloClient';
import { useLocation, useNavigate } from 'react-router-dom';
import SurveyComponent from './cloninger/SurveyCompopnentCloninger';
import UserChat from './userChat/selectUserChat';
import InputComponent from './inputSinfoco/InputComponent_sugerencias_3';

const useradmin = [
  process.env.REACT_APP_ADMIN,
  process.env.REACT_APP_ADMIN2,
  process.env.REACT_APP_ADMIN3,
  process.env.REACT_APP_ADMIN4,
  process.env.REACT_APP_ADMIN5,
  process.env.REACT_APP_ADMIN6,
  process.env.REACT_APP_ADMINJESI
];

const isAdmin = (currentUser) => {
  return useradmin.includes(currentUser);
};

const Suuseradmin = [
  process.env.REACT_APP_ADMIN,
  process.env.REACT_APP_ADMINJESI
];
const SupisAdmin = (currentUser) => {
  return Suuseradmin.includes(currentUser);
};

const Chat = () => {

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarLocked, setSidebarLocked] = useState(false); //// bloqueo para cerrar manualmente el sidebar
  const [selectedPostId, setSelectedPostId] = useState(null);

  const [showDropdown, setShowDropdown] = useState(false);
  useClickOutside(showDropdown, setShowDropdown);
  const [currentChat, setCurrentChat] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuscripcionesOpen, setSuscripcionesOpen] = useState(false);
  const [isModalHELP, setIsModalHELP] = useState(false);
  const [messageInput, setMessageInput] = useState('');
  const [isStreaming, setIsStreaming] = useState(false);
  const [selectedUser, setSelectedUser] = useState('Selecionar usuario');
  const [idUserlink, setSidUserlink] = useState('');

  const [dobPendienteUser, setDobPendienteUser] = useState(null); // NUEVO
  const [dobInput, setDobInput] = useState(''); // NUEVO

  const [showLoading, setShowLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(<span className='loading-text'>Analizando patrón conductual...</span>);

  const [isLoadingFecha, setIsLoadingFecha] = useState(false);
  const [loadingMessageFecha, setLoadingMessageFecha] = useState(<span className='loading-text'>Actualizando datos del usuario...</span>);

  const [selectedModel, setSelectedModel] = useState("Conductual básico");

  const messagesEndRef = useRef(null);
  const bodymessagesEndRef = useRef(null);
  const isScrolledToBottom = useScrollToBottom(bodymessagesEndRef);
  const { user, isAuthenticated, isLoading } = useAuth0();
  const { loginWithRedirect, logout } = useAuth0();
  const navigate = useNavigate();
  const [submitComment] = useMutation(SUBMIT_COMMENT_MUTATION);
  const username = user?.sub?.replace(/[^a-zA-Z0-9]/g, '');
  const email = user?.email;

  const location = useLocation();

  const [agregarFechaNacimiento] = useMutation(AGREGAR_FECHA_USER);

  const { data: userConductualData, loading: loadingUserConductual, error: userConductualError, refetch: refetchUser } = useQuery(FETCH_USERCONDUCTUAL_QUERY, {
    variables: { username, email },
    skip: !isAuthenticated

  });

  const { data: userConductualLinkData, loading: userConductualLinkLoading, error: userConductualLinkError, refetch: refetch } = useQuery(FETCH_USERCONDUCTUAL_LINK_QUERY, {
    variables: { username },
    skip: !isAuthenticated || !userConductualData
  });

  // flag para no refetchear infinitamente
  const [triedRefetchLink, setTriedRefetchLink] = useState(false);

  // si ya cargó, no hay datos y nunca habíamos refetcheado, entonces refetch
  useEffect(() => {
    const list = userConductualLinkData?.getUsersLinkByUsername;
    if (
      !userConductualLinkLoading &&
      list &&
      list.length === 0 &&
      !triedRefetchLink
    ) {
      setTriedRefetchLink(true);
      refetch();
    }
  }, [
    userConductualLinkLoading,
    userConductualLinkData,
    triedRefetchLink,
    refetch
  ]);




 
  const userConductual = userConductualData?.getUserconductual;
  const destinatario = location.state?.destinatario || '';


  useEffect(() => {
    if (location.state?.refetchNeeded) {
      refetch();
    }
  }, [location.state, refetch]);


  useEffect(() => {
    if (isAuthenticated) {
      refetch();
    }
  }, [isAuthenticated, refetch]);

  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= breakpoint);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  const isMobile = useIsMobile(); // Esto te dice si estás en modo responsive





  const [botResponses, setBotResponses] = useState([]);
  useEffect(() => {
    const newBotResponses = currentChat.filter(message => message.sender === 'bot' && !botResponses.includes(message.text));
    setBotResponses(prevBotResponses => [
      ...prevBotResponses,
      ...newBotResponses.map(message => message.text)
    ]);
  }, [currentChat, messageInput]);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
    }
  };

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const [showInfo, setShowInfo] = useState(false);
  const [showCopyIcon, setShowCopyIcon] = useState(true);

  const handleCopy = () => {
    const chatText = currentChat.map(message => `${message.sender}: ${message.text}`).join('\n');
    navigator.clipboard.writeText(chatText);
    setShowInfo(true);
    setShowCopyIcon(false);
    setTimeout(() => {
      setShowInfo(false);
      setShowCopyIcon(true);
    }, 1500);
  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Previene el salto de línea
      sendMessage(e);     // Envía el mensaje
    }
    // Si es Shift + Enter, no se hace nada: se permite salto de línea
  };

  const [createdPost, setCreatedPost] = useState(null);

  const createPostMutation = () => {
    return client.mutate({
      mutation: CREATE_POST_MUTATION,
      variables: { body: 'Nuevo chat', username: username, idUserlink: idUserlink },
      onCompleted: (data) => {
        console.log('Mutación completada: ', data);
      },
      onError: (error) => {
        console.error('Error en la mutación: ', error);
      }
    });
  };

  const callCreatePost = async (refetch) => {
    try {
      const response = await createPostMutation();
      /// console.log("Llamada a createPostMutation exitosa:", response.data.createPost.id);
      const postId = response.data.createPost.id;
      setSelectedPostId(postId);  // <-- nuevo
      setShowLoading(false);
      navigate(`/chat/${postId}`);
    } catch (error) {
      console.error("Error al llamar a createPostMutation:", error);
    }
  };

  const handleNewChat = () => {
    callCreatePost();
  };

  const sendMessage = () => {
    if (messageInput.trim() !== '') {
      const callCreatePost = async (refetch) => {
        try {
          const response = await createPostMutation();
          const postId = response.data.createPost.id;

          await submitComment({
            variables: { postId: postId, body: messageInput, username: username, idUserlink: idUserlink, modelo: selectedModel || "Conductual básico" },
          });

          //await refetch();
          navigate(`/chat/${postId}`, { state: { selectedUser, selectedPostId, selectedModel } });
        } catch (error) {
          console.error("Error al llamar a createPostMutation o submitComment:", error);
        }
      };
      setShowLoading(true);
      callCreatePost();
      setMessageInput('');
    }
  };



  const sampleDataOwner = {
    getUserconductual: userConductual,
  };

  const userConductualLINK = userConductualLinkData?.getUsersLinkByUsername || [];

  const idUserlinkquery = String(userConductual?.id ?? '');
  const dob = String(userConductual?.dob ?? '');


  const michat = {
    __typename: 'getUsersLinkByUsername',
    id: idUserlinkquery,////idUserlinkquery,
    nombres: 'Yo mism@',
    dob: dob,
    createdAt: "2024-11-28T00:08:11.021Z",
  };


  const sampleData = {
    getUsersLinkByUsername: [...userConductualLINK],
  };





  const handleNameSelect = async (item) => {
    let userToSet = item;  // por defecto, el mismo objeto que viene de la lista

    try {
      const { data } = await refetch();
      // si lo encuentra en la BD, lo usamos; si no, nos quedamos con item
      userToSet = data.getUsersLinkByUsername.find(u => u.id === item.id) || item;
    } catch (error) {
      console.error("Error al refetchear usuarios:", error);
      // dejamos userToSet === item
    }

    setSelectedUser(userToSet);

    if (userToSet.dob === 'pendiente') {
      setDobPendienteUser(userToSet);
      // no seteamos idUserlink aún
    } else {
      setDobPendienteUser(null);
      setSidUserlink(userToSet.id);

      if (!sidebarLocked) {
        setSidebarOpen(true);
      }
    }
  };





  const formatDate = (date) => {
    const [year, month, day] = date.split('-');
    return `${day}${month}${year}`;
  };

  const handleSubmitDOB = async () => {
    if (dobInput.trim()) {
      const formattedDob = formatDate(dobInput);
      setIsLoadingFecha(true); // Activar loading visual

      try {
        await agregarFechaNacimiento({
          variables: {
            id: dobPendienteUser.id,
            dob: formattedDob,
            perfil: dobPendienteUser.disc,
          },
        });

        await refetch();

        const updatedUser = userConductualLINK.find(u => u.id === dobPendienteUser?.id);
        setSelectedUser(updatedUser);
        setDobPendienteUser(null);
        setDobInput('');
      } catch (error) {
        console.error('Error al agregar fecha de nacimiento:', error);
      } finally {
        setIsLoadingFecha(false); // Desactivar loading en cualquier caso
      }
    }
  };



  const handleSupervisar = () => {
    localStorage.clear()
    navigate(`/miequipo`)
  };

  const handleCloninger = () => {
    localStorage.clear()
    navigate(`/tci`)
  };

  return (
    <>
      {isAuthenticated && (
        <div className="profile-container">
          {/* MENU DESPLEGABLE, Y LOGO QUE ESTA EN EL HEADER #PUBLICO# [Salir, Entrenar, Suscripcion, Gestionar Links]*/}

          <div id="dropdown" className="dropdown">
            <img src={user.picture} alt={user.name} onClick={handleDropdownToggle} />
            {showDropdown && (
              <div className="dropdown-menu">

               <button><a className='button-link' href="#" onClick={() => navigate(`/equipos`)}>Crear equipo</a></button>
               

                {isAdmin(user.sub) && selectedUser !== 'Selecionar usuario' && (<button className='button-link' onClick={() => navigate(`/trained`, { state: { selectedUser } })}>Entrenar</button>)}
                {isAdmin(user.sub) && selectedUser !== 'Selecionar usuario' && (<button className='button-link' onClick={() => navigate(`/altaEmpresa`, { state: { selectedUser } })}>Altas</button>)}

                {isAdmin(user.sub) && (<button><a className='button-link' href="#" onClick={handleSupervisar}>Supervisar</a></button>)}
                
                <button >
                  <a className='button-link' href="#" onClick={(e) => { e.preventDefault(); localStorage.clear(); logout({ logoutParams: { returnTo: window.location.origin } }); }}>Salir</a>
                  <FaSignOutAlt className="icon-spacing" />
                </button>

              </div>
            )}
          </div>
        </div>
      )}

      <div className="chat-container">
        {isAuthenticated && userConductual && !createdPost && showLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>{loadingMessage}</div>
        ) : (!createdPost && userConductual && userConductual !== null && (
          <div className={`spinner-container ${!sidebarOpen && 'expanded'}`}>
            <div>
              {selectedUser === 'Selecionar usuario' && (
                <h2>
                  Hola, <span style={{ color: '#808080', fontWeight: 300 }}>selecciona un usuario para comenzar a interactuar con el agente conductual...</span>
                </h2>
              )}

              {dobPendienteUser && (
                <div className="input-step" style={{ marginTop: '20px' }}>

                  {isLoadingFecha ? (
                    <div style={{
                      display: 'flex', justifyContent: 'center', alignItems: 'center',
                      height: '100vh', position: 'fixed', top: '50%', left: '50%',
                      transform: 'translate(-50%, -50%)'
                    }}>
                      {loadingMessageFecha}
                    </div>
                  ) : (
                    <>
                      <h3>
                        Ingresa la fecha de nacimiento de <span style={{ color: '#808080', fontWeight: 300 }}>{dobPendienteUser.nombres}</span>
                      </h3>
                      <input
                        type="date"
                        value={dobInput}
                        onChange={(e) => setDobInput(e.target.value)}
                        style={{ padding: '8px', margin: '10px 0', fontSize: '1rem' }}
                      />
                      <button
                        className="navi-button-user-date"
                        onClick={handleSubmitDOB}
                      >
                        Enviar
                      </button>
                    </>
                  )}

                </div>
              )}



              {!dobPendienteUser && selectedUser.id === idUserlinkquery && userConductual !== null && (
                <h1>
                  Hola, <span style={{ color: '#808080', fontWeight: 300 }}>¿en qué puedo ayudarte?</span>
                </h1>
              )}

              {!dobPendienteUser && selectedUser.id !== idUserlinkquery && userConductual !== null && selectedUser !== 'Selecionar usuario' && (
                <h3>
                  Hola, <span style={{ color: '#808080', fontWeight: 300 }}>¿qué te gustaría saber sobre</span> {selectedUser.nombres}?
                </h3>
              )}


            </div>
          </div>
        ))}

        {userConductual === null && (
          <div >

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                maxWidth: '500px',
                margin: '0 auto',
              }}
            >
              <SurveyComponent user={user.sub} email={user.email} refetch={refetch} refetchUser={refetchUser}/>
            </div>
          </div>
        )}

        <div className="floating-menu">
          {userConductual !== null && (<UserChat data={sampleData} onNameSelect={handleNameSelect} initialSearchTerm={destinatario} sidebarOpen={sidebarOpen} />)}
          {/* MENU DESPLEGABLE, Y LOGO QUE ESTA EN EL HEADER #PUBLICO# [Login]*/}
          {!isAuthenticated && (<img src='/images/LOGO-conductualGPT-01.svg' className="floating-menu-logo" />)}

          {isAuthenticated && selectedUser !== 'Selecionar usuario' && (<img src='/images/LOGO-conductualGPT-01.svg' className={`floating-menu-logo-2 ${!sidebarOpen && 'collapsed'}`} />)}

          {selectedUser === 'Selecionar usuario' && (<img src='/images/LOGO-conductualGPT-01.svg' className={`floating-menu-logo ${!sidebarOpen && 'collapsed'}`} />)}

          <div className="sidebar-buttons">
            {!isAuthenticated && (
              <button onClick={() => loginWithRedirect()}>
                <FaSignInAlt />
                <span>Ingresar</span>
              </button>
            )}
          </div>

        </div>

        {/* {selectedUser !== 'Seleccionar usuario'&& (*/}
        {isAuthenticated && selectedUser !== 'Selecionar usuario' && !dobPendienteUser && (
          <div>
            <ToolTipBarra sidebarOpen={sidebarOpen} content={sidebarOpen ? 'Cerrar barra lateral' : 'Abrir barra lateral'}>
              <div
                className={`sidebar-toggle ${!sidebarOpen && 'collapsed'}`}
                onClick={() => { setSidebarOpen(!sidebarOpen); setSidebarLocked(!sidebarLocked) }}
                style={{
                  position: 'fixed',
                  left: sidebarOpen ? '206px' : '20px',
                  top: '6px',
                  zIndex: 1000,
                  transition: 'all 0.3s ease',
                  background: '#fff',
                  border: '0px solid #ddd',
                  borderRadius: '50%',
                  width: '33px',
                  height: '33px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}
              >
                {isMobile ? (sidebarOpen ? '✕' : '☰') : (sidebarOpen ? '✕' : '☰')}
              </div>
            </ToolTipBarra>

            <div className={`sidebar ${!sidebarOpen && 'closed'}`}>

              <div className="button-group">
                <ButtonGroup
                  handleNewChat={handleNewChat}
                  handleCopy={handleCopy}
                  showCopyIcon={showCopyIcon}
                  username={username}
                  idUserlink={idUserlink}
                />

              </div>

              <div className="history-section">
                <p>Historial</p>
                <FilteredPosts selectedPostId={selectedPostId} user={user.sub} idUserlink={idUserlink} />
              </div>
            </div>
          </div>
        )}
        {isAuthenticated && userConductual !== null && selectedUser !== 'Selecionar usuario' && !dobPendienteUser && (
          <div className={`input-container-text ${!sidebarOpen && 'expanded'}`}>
            <InputComponent messageInput={messageInput} setMessageInput={setMessageInput} handleKeyDown={handleKeyDown} sendMessage={sendMessage} isStreaming={showLoading} selectedModel={selectedModel} setSelectedModel={setSelectedModel} selectedUser={selectedUser}
            />
          </div>
        )}
        <div className={`main ${!sidebarOpen && 'expanded'}`}>

          <div className="disclaimer-base-container">
            <p>Copilot Nawi-GPT ™ 2025 | by Neuraldinamica LLC</p>
            <a className='button-link2' href="#" onClick={() => setIsModalOpen(true)}>Términos de uso.</a>
          </div>
        </div>


        {isAuthenticated && (
          <>
            {bodymessagesEndRef.current && !isScrolledToBottom && (
              <div className="scroll-to-bottom" onClick={scrollToBottom}>
                <FaArrowDown />
              </div>
            )}
          </>
        )}

        <div className="disclaimer-base-container-terminos">

          <Terminos isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
          <Suscripciones isOpen={isSuscripcionesOpen} onClose={() => setSuscripcionesOpen(false)} />

        </div>




      </div>
    </>
  );
};


// NUEVA MUTACIÓN AGREGADA
const AGREGAR_FECHA_USER = gql`
  mutation($id: ID!, $dob: String!, $perfil: String!) {
    agregarFechaNacimiento(id: $id, dob: $dob, perfil: $perfil)
  }
`;

const FETCH_USERCONDUCTUAL_QUERY = gql`
  query($username: String!, $email: String!) {
    getUserconductual(username: $username, email: $email) {
      id
      username
      disc
      eneagrama
      bigfive
    }
  }
`;


const FETCH_USERCONDUCTUAL_LINK_QUERY = gql`
  query($username: String!) {
    getUsersLinkByUsername(username: $username) {
      id
      nombres
      dob
      email
      disc
      createdAt
    }
  }
`;

const SUBMIT_COMMENT_MUTATION = gql`
  mutation($postId: String!, $body: String!, $username: String!, $idUserlink: String!, $modelo: String!) {
    createComment(postId: $postId, body: $body, username: $username, idUserlink: $idUserlink, modelo: $modelo) {
      id
      comments {
        id
        idUserlink
        body
        respuesta
        createdAt
        username
      }
      commentCount
    }
  } 
`;

const CREATE_POST_MUTATION = gql`
  mutation createPost($body: String!, $username: String!, $idUserlink: String!) {
    createPost(body: $body, username: $username, idUserlink: $idUserlink) {
      id
      body
      estado
      createdAt
      username
      likes {
        id
        username
        createdAt
      }
      likeCount
      comments {
        id
        body
        respuesta
        username
        createdAt
      }
      commentCount
    }
  }
`;

export default Chat;